import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AuthComponentsModule, AuthGmsAngularClientModule } from '@coin/shared/auth/feature';
import { AuthGmsClientConfig } from '@coin/shared/auth/util';
import { environment } from '@coin/shared/core/util-environments';
import { NgxsModule } from '@ngxs/store';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgxsModule.forRoot(),
    AuthGmsAngularClientModule.forRoot({
      ...environment.authentication,
      ...environment.storybookAuthentication
    } as AuthGmsClientConfig),
    AuthComponentsModule
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
  exports: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
